'use strict';

var Sugar = require('sugar-core'),
    objectSize = require('./internal/objectSize');

Sugar.Object.defineInstanceAndStatic({

  'size': function(obj) {
    return objectSize(obj);
  }

});

module.exports = Sugar.Object.size;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/object/size.js
// module id = 835
// module chunks = 0